export interface AccessRow {
  format: string;
  pages: string;
}

export const accessRows: AccessRow[] = [
  { format: '📖 6 tomos en PDF', pages: '361 páginas' },
  { format: '💪 5 bonos en PDF', pages: '160 páginas' }
];

export const accessChecks: string[] = [
  'PDF de alta calidad',
  'Imprimible en A4',
  'Optimizado para móvil y tablet',
  'Acceso inmediato sin esperas'
];

export const accessSummary =
  'Una colección con 60 ejercicios diferentes, 58 planes de sesión, 18 rutinas físicas y plantillas imprimibles para preparar, observar y ajustar el entrenamiento.';

export const accessDetail =
  'Los 58 planes incluyen 48 sesiones del Cronograma Maestro y 10 de Sesiones Críticas. Las sesiones combinan ejercicios del banco. El calendario de 40 semanas incluye repeticiones planificadas.';
